<!-- Notification Toast Container (fixed top-right) -->
<div class="fixed top-4 right-4 z-50 flex w-full max-w-sm flex-col gap-3">
  @for (notification of notifications(); track notification.id) {
    <div  [class]="getAlertClass(notification.type)">
      <div class="flex flex-col gap-1 flex-1">
        <!-- Title and Close Button -->
        <div class="flex items-start justify-between gap-2">
          <div class="flex items-center gap-2">
            <span class="text-lg font-bold">{{ getIcon(notification.type) }}</span>
            <span class="font-semibold">{{ notification.title }}</span>
          </div>
          <button
            type="button"
            
            (click)="dismiss(notification.id)"
            title="Dismiss">
            ×
          </button>
        </div>

        <!-- Message -->
        <p class="text-sm">{{ notification.message }}</p>

        <!-- Action Button (if provided) -->
        @if (notification.action) {
          <button
            type="button"
            class="mt-2"
            (click)="executeAction(notification.id, notification.action.callback)">
            {{ notification.action.label }}
          </button>
        }
      </div>
    </div>
  }
</div>
